export default "__VITE_ASSET__BXXIBXsI__"